import React, { ReactNode, useCallback, useState } from 'react'

import { Popover } from '@tribeplatform/react-ui-kit/Popover'

import { ImagePickerProps, ImagePickerTabs } from './ImagePicker.js'

type PopoverImagePickerProps = ImagePickerProps & {
  children: ReactNode
}

export const PopoverImagePicker = ({
  children,
  ...rest
}: PopoverImagePickerProps) => {
  const [active, setActive] = useState(false)
  const toggleActive = useCallback(() => setActive(active => !active), [])
  const onClose = useCallback(() => setActive(false), [])

  const activator = <div onClick={toggleActive}>{children}</div>

  return (
    <Popover
      activator={activator}
      open={active}
      onClose={onClose}
      autofocusTarget="first-node"
      fluidContent
    >
      <ImagePickerTabs onSelect={onClose} {...rest} />
    </Popover>
  )
}
